export const comment = 'comment';
export const question = 'question';
export const imporvement = 'imporvement';
export const bug = 'bug';

export const getFeedbackTabs = (permissions) => {
  return [
    {
      name: comment,
      path: `/feedback/${comment}`,
      label: 'Leave a comment',
      title: 'Leave a comment',
      show: permissions?.[comment]?.allowView,
    },
    {
      name: question,
      path: `/feedback/${question}`,
      label: 'Ask a question',
      title: 'Ask a question',
      show: permissions?.[question]?.allowView,
    },
    {
      name: imporvement,
      path: `/feedback/${imporvement}`,
      label: 'Suggest an improvement',
      title: 'Suggest an improvement',
      show: permissions?.[imporvement]?.allowView,
    },
    {
      name: bug,
      path: `/feedback/${bug}`,
      label: 'Report a bug',
      title: 'Report a bug',
      show: permissions?.[bug]?.allowView,
    },
  ];
};
